import { render, staticRenderFns } from "./polygon-modal.vue?vue&type=template&id=3a556fac&scoped=true&"
import script from "./polygon-modal.vue?vue&type=script&lang=js&"
export * from "./polygon-modal.vue?vue&type=script&lang=js&"
import style0 from "./polygon-modal.vue?vue&type=style&index=0&id=3a556fac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a556fac",
  null
  
)

export default component.exports